/** Two-letter uppercase initials from a display name. */
export function initials(name, fallback = "?") {
  return (name || fallback).split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
}
